module.exports = __webpack_public_path__ + "img/idebit.3a89ce82.svg";